const comprueboPermisos = (permisos, palabra) => {
  if (!permisos || !palabra) return false;

  const lista = Array.isArray(permisos)
    ? permisos
    : String(permisos).split(",");

  return lista.some(
    (permiso) =>
      String(permiso).trim().toLowerCase() ===
      String(palabra).trim().toLowerCase()
  );
};

export default comprueboPermisos;